import * as React from 'react';
import { SVGProps } from 'react';

const IconMMPSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H17l2.727 10H22.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2.773L11 5H9.5a.5.5 0 0 1-.5-.5v-2ZM14.818 8l1.91 7h-5.455l1.909-7h1.636Z"
    />
    <path d="M25 24.5a.5.5 0 0 0-.5-.5h-21a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5v-1ZM22.779 22.564l2.883-.983a.5.5 0 0 0 .338-.473v-1.433a.5.5 0 0 0-.646-.478l-3.202.978a1.311 1.311 0 0 1-.802-.057l-1.427-.585c-1.001-.41-2.188-.372-3.148.1l-.743.365c-.3.147-.67.168-.991.055l-1.863-.654a3.932 3.932 0 0 0-2.753.066l-1.516.622a1.312 1.312 0 0 1-.871.037l-2.582-.793a3.934 3.934 0 0 0-2.613.112l-.58.313a.5.5 0 0 0-.263.44v1.46a.5.5 0 0 0 .667.471l1.152-.408c.271-.11.587-.124.87-.037l2.583.793a3.935 3.935 0 0 0 2.612-.112l1.517-.621a1.31 1.31 0 0 1 .918-.023l1.862.654c.966.34 2.072.278 2.973-.165l.744-.365c.32-.158.715-.17 1.049-.033l1.428.585a3.935 3.935 0 0 0 2.404.17Z" />
  </svg>
);
export default IconMMPSizeL;
